export const isValidSubdomain = (subdomain) => !!subdomain && subdomain !== 'root' && subdomain !== '_';
